// extracted by mini-css-extract-plugin
export var divider = "_ns-0";
export var systemMessage = "_ns-1";
export var systemMessageWrapper = "_ns-2";